import {Pipe, PipeTransform} from "@angular/core";
import {onlyUnique} from "../../functions/meta.functions";
import {FormatGeometergeschaeftsnummerPipe} from "../format/format-geometergeschaeftsnummer.pipe";
import {GeometergeschaeftListEntryMeta} from "../../../core/av-api/model/geometergeschaeftListEntryMeta";
import {ComparatorService} from "../../services/comparator-service";

@Pipe({
  name: 'orderByGeoGeschaeft'
})
export class OrderByGeoGeschaeftPipe implements PipeTransform {

  public constructor(private formatGeoTimePointPipe: FormatGeometergeschaeftsnummerPipe,
                     private comparatorService: ComparatorService) {
  }

  transform(array, ascending = true) {
    if (!array) {
      return;
    }
    if (ascending) {
      return Array.from(array).filter(onlyUnique).sort((item1: any, item2: any) => {
        return this.orderByGeschaeft(item1, item2);
      });
    } else {
      return Array.from(array).filter(onlyUnique).sort((item1: any, item2: any) => {
        return this.orderByGeschaeft(item2, item1);
      });
    }
  }

  orderByGeschaeft(a: GeometergeschaeftListEntryMeta,
                   b: GeometergeschaeftListEntryMeta): number {
    const geoA: GeometergeschaeftListEntryMeta = <GeometergeschaeftListEntryMeta>a;
    const geoB: GeometergeschaeftListEntryMeta = <GeometergeschaeftListEntryMeta>a;
    return this.comparatorService.orderByComparator(this.formatGeoTimePointPipe.transform(geoA.geometergeschaeft.timePoint.geschaeftsnummer),
      this.formatGeoTimePointPipe.transform(geoB.geometergeschaeft.timePoint.geschaeftsnummer));
  }

}
